import styled from 'styled-components'
import { space, typography, color, layout } from 'styled-system'

const StyledHeader = styled.div`
  ${space}
  ${color}
  ${typography}
  ${layout}
`
StyledHeader.defaultProps = {
  letterSpacing: 'header',
  fontWeight: 'bold',
  fontSize: 'header.regular',
  lineHeight: 'header.regular'
}

const Header = ({ variant = 'header.regular', ...others }) =>
  <StyledHeader fontSize={variant} lineHeight={variant} {...others} />

export default Header
